export default __webpack_public_path__ + "static/media/wave-health.37a56671.png";